import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { PricingRoutes } from 'pricing/types';
import { testId } from 'pricing/utilities/test/dataTestId';

function ContractEditHeaderAction() {
  const history = useHistory();

  const handleNavigateTo = () => history.push(PricingRoutes.ContractList);

  return (
    <Button
      data-testid={testId.contractEditHeaderAction}
      onClick={handleNavigateTo}
      icon={<ArrowLeftOutlined />}
    >
      Exit
    </Button>
  );
}

export default ContractEditHeaderAction;
